
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedOpen as ObiThreewayStackedOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-open.js';
 
 
 

 
 export const ObiThreewayStackedOpen = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-open',
   elementClass: ObiThreewayStackedOpenElement,
   events: {
     
   }
  });
 
 